import { useIsClamped } from '@/hooks/useIsClamped';
import { useGlobalContainerRef } from '@/wc/helper/ref';
import { Tooltip } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import React from 'react';
import styles from './TooltipCell.module.scss';

const cx = classnames.bind(styles);

export type TooltipCellProps = {
  title: React.ReactNode;
  className?: string;
  wrapperClassName?: string;
  children: React.ReactNode;
  /**
   * Default `true`: always show the tooltip regardless of truncation
   * (original behavior, relied on by the main invoice list). Pass `false`
   * to only show it once the content is actually clamped (NA-5596 AC4).
   */
  alwaysShow?: boolean;
};

export const TooltipCell: React.FC<TooltipCellProps> = ({
  title,
  className,
  children,
  wrapperClassName,
  alwaysShow = true,
}) => {
  const container = useGlobalContainerRef();
  const { ref, isClamped } = useIsClamped<HTMLDivElement>(children);
  const shouldShowTooltip = alwaysShow || isClamped;

  return (
    <Tooltip
      title={shouldShowTooltip ? title : undefined}
      overlayClassName={cx(styles['tooltipContainer'], wrapperClassName)}
      getPopupContainer={container}
      destroyTooltipOnHide
    >
      <div className={cx(styles['tooltipCellWrapper'], 'tooltip-cell-wrapper')}>
        <div ref={ref} className={cx(styles['ellipsisText'], className)}>
          {children}
        </div>
      </div>
    </Tooltip>
  );
};
